import type {
    CreateProgramPolicyInput,
    CreateProgramPolicyResponse,
    ProgramPoliciesResponse,
    UpdateProgramPolicyValueInput,
    UpdateProgramPolicyValueResponse
} from "@/types/programPolicies";

import {
    clientProgramViewsToClientRunPrograms,
    clientProgramViewsToPolicyDefinitions
} from "./clientProgramPresentation";
import { fetchClientPrograms } from "./clientPrograms";
import { orgApiFetch } from "./orgApiFetch";

export async function fetchProgramPolicies(): Promise<ProgramPoliciesResponse> {
    const response = await fetchClientPrograms();
    return {
        programs: clientProgramViewsToClientRunPrograms(response.data),
        policies: clientProgramViewsToPolicyDefinitions(response.data),
        snapshotAt: new Date().toISOString()
    };
}

export function createProgramPolicy(input: CreateProgramPolicyInput): Promise<CreateProgramPolicyResponse> {
    return orgApiFetch<CreateProgramPolicyResponse>("/api/org/client/program-policies", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input)
    });
}

export function updateProgramPolicyValue({
    policyUuid,
    parameters,
    scopeType,
    scopeTargetUuids
}: UpdateProgramPolicyValueInput): Promise<UpdateProgramPolicyValueResponse> {
    return orgApiFetch<UpdateProgramPolicyValueResponse>(`/api/org/client/program-policies/${policyUuid}/value`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ parameters, scopeType, scopeTargetUuids })
    });
}
